import { ToastDiv } from './StyleToast'

const Toast = ({ text }) => {
  return <ToastDiv>{text}</ToastDiv>
}

export default Toast
